export interface WalletListFilter {
  page?: number | null;
  count?: number | null;
  sort_key?: string | null;
  sort_by?: string | null;
  sender_id?: number[] | null;
  partner_id?: number[] | null;
}

export const defaultWalletListFilter: WalletListFilter = {
  page: 0,
  count: 10,
  sort_key: '',
  sort_by: '',
  sender_id: null,
  partner_id: null,
};
